if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      if (this.addButton && this.addHandler) {
        this.addButton.removeEventListener('click', this.addHandler);
      }
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      // Single-variant products get a real add-to-cart in the sticky bar. Rather than
      // POSTing to /cart/add.js separately, click the form's own submit button so the
      // add goes through exactly the same path as the main button: same validation, same
      // events, same behaviour from any app that hooks the form.
      this.addButton = this.querySelector('.js-sticky-atc');
      if (this.addButton) {
        this.addHandler = this.handleStickyAdd.bind(this);
        this.addButton.addEventListener('click', this.addHandler);
      }

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Adds to cart from the sticky panel by delegating to the real product form.
     */
    handleStickyAdd() {
      const submitBtn = this.productForm && this.productForm.querySelector('[name="add"]');

      if (!submitBtn || submitBtn.getAttribute('aria-disabled') === 'true' || submitBtn.disabled) {
        // Nothing to submit, or an add is already in flight. Fall back to showing the buy
        // box rather than leaving the tap with no result at all.
        if (this.productInfo) this.productInfo.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      submitBtn.click();
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
